import { useNavigate } from 'react-router-dom'
import Modal from './Modal'
import React from 'react'

interface ChooseProfileOrCreateNewModalProps {
  body: board.Board[]
  onClose: () => void
}

const ChooseProfileOrCreateNewModal: React.FC<ChooseProfileOrCreateNewModalProps> = ({ body, onClose }) => {
  const navigate = useNavigate()

  return (
    <Modal
      title={`Posiadasz jeszcze ${body.length === 1 ? '1 nieuzupełniony profil' : body.length < 5 ? `${body.length} nieuzupełnione profile` : `${body.length} nieuzupełnionych profili`}!`}
      onClose={onClose}>
      <div className="modal__chooseProfile">
        <p>Czy może zamiast tworzenia nowego wolisz uzupełnić już istniejący profil?</p>
        {body[0] && <div
          className="profile__item black"
          onClick={() => {
            onClose()
            navigate(`/addprofile/${body[0].id}/update`)
          }}>
          <div className="profile__item__name">
            {body[0].name}
          </div>
        </div>}
        <div
          className="profile__item"
          onClick={() => {
            onClose()
            navigate('/addprofile')
          }}>
          <div className="profile__item__name">
            Utwórz nowy profil
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ChooseProfileOrCreateNewModal